import { MenuItem, TextField } from "@mui/material";

import type { FolderOption } from "./folderOptions.js";

/**
 * The ONE folder picker for filing a document: top-level folders with their
 * sub-folders indented beneath them (two levels). The closed select shows
 * "Videos / R11.0 / Command Control" so the choice reads unambiguously. Shared by the
 * Upload, Bulk-upload and manual-document forms.
 */
export function FolderSelect({
  folders,
  value,
  onChange,
  label = "Folder",
  emptyLabel = "None",
  helperText,
}: {
  folders: FolderOption[];
  value: string;
  onChange: (next: string) => void;
  label?: string;
  emptyLabel?: string;
  helperText?: string;
}): JSX.Element {
  return (
    <TextField
      select
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      {...(helperText ? { helperText } : {})}
      SelectProps={{
        renderValue: (v) => {
          if (v === "" || v == null) return emptyLabel;
          return folders.find((f) => String(f.id) === String(v))?.label ?? String(v);
        },
        displayEmpty: true,
      }}
      InputLabelProps={{ shrink: true }}
      inputProps={{ "data-testid": "folder-select" }}
    >
      <MenuItem value="">{emptyLabel}</MenuItem>
      {folders.map((f) => (
        <MenuItem
          key={f.id}
          value={String(f.id)}
          data-testid={`folder-option-${f.id}`}
          sx={f.depth > 0 ? { pl: 2 + f.depth * 2, fontSize: 13 } : { fontWeight: 500 }}
        >
          {f.depth > 0 ? `↳ ${f.name}` : f.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
